module.exports = __webpack_public_path__ + "img/repairing-service.c52f2aff.png";